import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config/appConfig';

export default function FormNegocio({ negocioId, onClose, onSaved, onAuthError }) {
    const [formData, setFormData] = useState({
        nombre: '',
        plan: 'RESTAURANTE',
        cantidad_pos: 1,
        fecha_inicio: '',
        // 🚩 CAMPOS SII
        envia_boletas_sii: false,
        modo_sii: 'CERTIFICACION'
    });
    const [loading, setLoading] = useState(false);
    const [cargandoDatos, setCargandoDatos] = useState(false);
    const esEdicion = Boolean(negocioId);

    const token = localStorage.getItem('superadmin_token');
    const authHeaders = { headers: { 'token': token, 'Content-Type': 'application/json' } };

    useEffect(() => {
        if (negocioId) {
            cargarNegocio();
        }
    }, [negocioId]);

    const cargarNegocio = async () => {
        setCargandoDatos(true);
        try {
            const res = await axios.get(`${config.api_url}/api/bimba/negocios/${negocioId}`, authHeaders);
            if (res.data && res.data.status === "success") {
                const d = res.data.data;
                let fecha = d.fecha_corte_pago || '';
                if (fecha && fecha.includes(' ')) fecha = fecha.split(' ')[0];
                setFormData({
                    nombre: d.nombre || '',
                    plan: d.plan || 'RESTAURANTE',
                    cantidad_pos: d.cantidad_pos || 1,
                    fecha_inicio: fecha,
                    // 🚩 CAMPOS SII
                    envia_boletas_sii: Boolean(d.envia_boletas_sii),
                    modo_sii: d.modo_sii || 'CERTIFICACION'
                });
            } else {
                toast.error("Error al cargar datos del negocio");
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            toast.error(!err.response ? "No se pudo conectar con el servidor." : "Error de conexión");
        } finally {
            setCargandoDatos(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.nombre.trim()) {
            toast.warning("El nombre del negocio es obligatorio");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                ...formData,
                cantidad_pos: Number(formData.cantidad_pos),
            };

            if (formData.fecha_inicio) {
                payload.fecha_inicio = formData.fecha_inicio;
            }

            let res;
            if (esEdicion) {
                res = await axios.put(
                    `${config.api_url}/api/bimba/negocios/${negocioId}`,
                    payload,
                    authHeaders
                );
            } else {
                res = await axios.post(
                    `${config.api_url}/api/bimba/negocios`,
                    payload,
                    authHeaders
                );
            }

            if (res.data && res.data.status === "success") {
                toast.success(esEdicion ? "Negocio actualizado" : "Negocio creado correctamente");
                onSaved();
            } else {
                toast.error(res.data.message || "Error al guardar");
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            toast.error(!err.response ? "No se pudo conectar con el servidor." : "Error de conexión");
        } finally {
            setLoading(false);
        }
    };

    if (cargandoDatos) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '32px', height: '32px',
                        border: '3px solid #e5e7eb', borderTopColor: '#667eea',
                        borderRadius: '50%', animation: 'spin 0.6s linear infinite',
                        margin: '0 auto 12px'
                    }}/>
                    <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>Cargando datos del negocio...</p>
                </div>
            </div>
        );
    }

    const Switch = ({ id, checked, onChange, label, desc, icon }) => (
        <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '14px',
            padding: '16px',
            background: checked ? '#f0fdf4' : '#f9fafb',
            borderRadius: '12px',
            border: `1.5px solid ${checked ? '#bbf7d0' : '#e5e7eb'}`,
            transition: 'all 0.2s'
        }}>
            <div style={{
                width: '40px', height: '40px',
                background: checked ? '#dcfce7' : '#f3f4f6',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={checked ? '#10b981' : '#9ca3af'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d={icon}/>
                </svg>
            </div>
            <div style={{ flex: 1 }}>
                <label htmlFor={id} style={{
                    fontWeight: 600,
                    fontSize: '14px',
                    color: '#1a1a2e',
                    cursor: 'pointer',
                    display: 'block',
                    marginBottom: '2px'
                }}>{label}</label>
                <p style={{ color: '#6b7280', fontSize: '12px', margin: 0 }}>{desc}</p>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px', flexShrink: 0, cursor: 'pointer' }}>
                <input
                    type="checkbox"
                    id={id}
                    name={id}
                    checked={checked}
                    onChange={onChange}
                    style={{ opacity: 0, width: 0, height: 0, position: 'absolute' }}
                />
                <span style={{
                    position: 'absolute',
                    cursor: 'pointer',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: checked ? '#10b981' : '#d1d5db',
                    borderRadius: '24px',
                    transition: '0.3s'
                }}>
                    <span style={{
                        position: 'absolute',
                        content: '',
                        height: '18px', width: '18px',
                        left: checked ? '22px' : '3px',
                        bottom: '3px',
                        background: '#fff',
                        borderRadius: '50%',
                        transition: '0.3s',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
                    }}/>
                </span>
            </label>
        </div>
    );

    const icons = {
        web: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z',
        pedidos: 'M3 3h18v18H3V3zm2 2v14h14V5H5zm2 2h10v2H7V7zm0 4h10v2H7v-2zm0 4h7v2H7v-2z',
        kds: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z',
        qr: 'M3 3h7v7H3V3zm2 2v3h3V5H5zm-2 13h7v7H3v-7zm2 2v3h3v-3H5zM21 3h7v7h-7V3zm2 2v3h3V5h-3zm-2 13h7v7h-7v-7zm2 2v3h3v-3h-3z',
        propina: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z',
        telefono: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z'
    };

    return (
        <div style={{
            padding: '32px',
            maxWidth: '800px',
            margin: '0 auto',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
            {/* HEADER */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: '28px'
            }}>
                <div>
                    <h1 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#1a1a2e',
                        margin: '0 0 8px',
                        letterSpacing: '-0.5px'
                    }}>
                        {esEdicion ? 'Editar Negocio' : 'Nuevo Negocio'}
                    </h1>
                    <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>
                        {esEdicion ? 'Modifica los datos del negocio' : 'Registra un nuevo negocio en el sistema'}
                    </p>
                </div>
                <button onClick={onClose} style={{
                    padding: '10px',
                    background: '#fff',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    display: 'flex'
                }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round">
                        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                </button>
            </div>

            <form onSubmit={handleSubmit}>
                {/* DATOS GENERALES */}
                <div style={{
                    background: '#fff',
                    borderRadius: '16px',
                    border: '1px solid #f3f4f6',
                    padding: '28px',
                    marginBottom: '20px'
                }}>
                    <h3 style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#1a1a2e',
                        margin: '0 0 20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
                        </svg>
                        Datos Generales
                    </h3>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#374151',
                            marginBottom: '6px'
                        }}>Nombre del Negocio</label>
                        <input
                            type="text"
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            placeholder="Ej: Restaurante Donde Juan"
                            required
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                border: '1.5px solid #e5e7eb',
                                borderRadius: '10px',
                                fontSize: '14px',
                                outline: 'none',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '20px', maxWidth: '250px' }}>
                        <label style={{
                            display: 'block',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#374151',
                            marginBottom: '6px'
                        }}>Plan Comercial</label>
                        <select
                            name="plan"
                            value={formData.plan}
                            onChange={handleChange}
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                border: '1.5px solid #e5e7eb',
                                borderRadius: '10px',
                                fontSize: '14px',
                                outline: 'none',
                                background: '#fff',
                                color: '#374151',
                                boxSizing: 'border-box'
                            }}
                        >
                            <option value="MENU_QR">Komity Menú QR</option>
                            <option value="POS">Komity POS Take Away</option>
                            <option value="RESTAURANTE">Plan Restaurante</option>
                        </select>
                        <small style={{ color: '#9ca3af', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                            MENU_QR: catálogo y pedidos online. POS: TPV/comandas sin mesas. RESTAURANTE: todo + gestión de mesas.
                        </small>
                    </div>

                    <div style={{ marginBottom: '16px', maxWidth: '250px' }}>
                        <label style={{
                            display: 'block',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#374151',
                            marginBottom: '6px'
                        }}>Cantidad POS</label>
                        <input
                            type="number"
                            name="cantidad_pos"
                            value={formData.cantidad_pos}
                            onChange={handleChange}
                            min="1" max="50"
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                border: '1.5px solid #e5e7eb',
                                borderRadius: '10px',
                                fontSize: '14px',
                                outline: 'none',
                                boxSizing: 'border-box'
                            }}
                        />
                        <small style={{ color: '#9ca3af', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                            Terminales POS permitidos
                        </small>
                    </div>

                    <div style={{ marginTop: '16px' }}>
                        <label style={{
                            display: 'block',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#374151',
                            marginBottom: '6px'
                        }}>Fecha de Inicio del Servicio</label>
                        <input
                            type="date"
                            name="fecha_inicio"
                            value={formData.fecha_inicio}
                            onChange={handleChange}
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                border: '1.5px solid #e5e7eb',
                                borderRadius: '10px',
                                fontSize: '14px',
                                outline: 'none',
                                boxSizing: 'border-box'
                            }}
                        />
                        <small style={{ color: '#9ca3af', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                            Fecha en que el negocio comenzó a operar. El corte será el mismo día cada mes.
                        </small>
                    </div>
                </div>

                {/* MÓDULOS */}
                <div style={{
                    background: '#fff',
                    borderRadius: '16px',
                    border: '1px solid #f3f4f6',
                    padding: '28px',
                    marginBottom: '24px'
                }}>
                    <h3 style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#1a1a2e',
                        margin: '0 0 20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
                        </svg>
                        Módulos Habilitados
                    </h3>
                    <p style={{ color: '#9ca3af', fontSize: '12px', margin: '-12px 0 16px' }}>
                        Tienda Web, Pedidos y Menú QR ya no se configuran aquí: se activan solos según el Plan Comercial elegido arriba.
                    </p>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        {/* 🚩 MÓDULO SII */}
                        <Switch id="envia_boletas_sii" checked={formData.envia_boletas_sii} onChange={handleChange}
                            label="Boletas Electrónicas SII" desc="Emite boletas electrónicas al SII al cobrar" icon="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0 1 12 2.944a11.955 11.955 0 0 1-8.618 3.04A12.02 12.02 0 0 0 3 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                    </div>

                    {formData.envia_boletas_sii && (
                        <div style={{ marginTop: '16px', padding: '16px', background: '#f0fdf4', borderRadius: '12px', border: '1px solid #bbf7d0' }}>
                            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '6px' }}>
                                Modo SII
                            </label>
                            <select
                                name="modo_sii"
                                value={formData.modo_sii}
                                onChange={handleChange}
                                style={{
                                    width: '100%', padding: '12px 16px',
                                    border: '1.5px solid #bbf7d0', borderRadius: '10px',
                                    fontSize: '14px', outline: 'none', background: '#fff',
                                    color: '#374151', boxSizing: 'border-box'
                                }}
                            >
                                <option value="CERTIFICACION">🔬 Certificación (maullin.sii.cl)</option>
                                <option value="PRODUCCION">🚀 Producción (palena.sii.cl)</option>
                            </select>
                            <small style={{ color: '#6b7280', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                                Usar certificación para pruebas. Cambiar a producción solo cuando esté autorizado por el SII.
                            </small>
                        </div>
                    )}
                </div>

                {/* BOTONES */}
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                    <button type="button" onClick={onClose} style={{
                        padding: '12px 28px',
                        background: '#fff',
                        border: '1.5px solid #e5e7eb',
                        borderRadius: '10px',
                        color: '#374151',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                    }}>
                        Cancelar
                    </button>
                    <button type="submit" disabled={loading} style={{
                        padding: '12px 28px',
                        background: loading ? '#9ca3af' : '#1a1a2e',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: loading ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        {loading ? (
                            <div style={{
                                width: '16px', height: '16px',
                                border: '2px solid rgba(255,255,255,0.3)',
                                borderTopColor: '#fff',
                                borderRadius: '50%',
                                animation: 'spin 0.6s linear infinite'
                            }}/>
                        ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                                <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
                            </svg>
                        )}
                        {esEdicion ? 'Guardar Cambios' : 'Crear Negocio'}
                    </button>
                </div>
            </form>

            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
                input:focus {
                    border-color: #667eea !important;
                    box-shadow: 0 0 0 3px rgba(102,126,234,0.1);
                }
            `}</style>
        </div>
    );
}
